export default {
  siteKey: '6LcbM88ZAAAAAMuzJHc6i1cCm-tV9cQdoKSTOoti',
};
